import { useParams } from "react-router-dom";
import ChatPanel from "./ChatPanel";

const ChatPage = () => {
  const { conversationId } = useParams();

  return (
    <div>
      <ChatPanel conversationId={conversationId} />
    </div>
  );
};

export default ChatPage;
